export default __webpack_public_path__ + "static/marquiz-1fd099449355227a66fc5b6f36a8ba23.png";